export const formLabelStyle = {
  color: 'var(--cm-color-text-primary)',
  fontSize: '14px',
  fontWeight: 700,
}
export const formItemPopoverOpt =  {
  trigger: 'hover',
  effect: 'dark',
  placement: 'top',
  content: '请填写您的联系方式',
}
